import { Component, OnInit } from '@angular/core';
import { EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { RecuperacaoCreditoService } from './recuperacao-credito.service';
import { RecuperacaoCredito } from 'src/app/model/recuperacao-credito.model';

@Component({
    selector: 'app-recuperacoes-inconsistentes',
    templateUrl: './recuperacoes-inconsistentes.component.html',
    standalone: false
})
export class RecuperacoesInconsistentesComponent implements OnInit {
    public recIncAposSaldoComBeneficiarioLiquidado: RecuperacaoCredito[] = [];
    public recIncAposCobrancaEncerradaInformada: RecuperacaoCredito[] = [];
    public recIncAposLiquidacaoInformada: RecuperacaoCredito[] = [];

    public somenteResolvidasAposSaldoComBeneficiarioLiquidado: boolean;
    public somenteResolvidasAposCobrancaEncerradaInformada: boolean;
    public somenteResolvidasAposLiquidacaoInformada: boolean;

    public atributosPaginacaoComponenteListagemAposSaldoComBeneficiarioLiquidado: EntityPagedResult<RecuperacaoCredito>;
    public opcoesPaginacaoAposSaldoComBeneficiarioLiquidado: number[];

    public atributosPaginacaoComponenteListagemAposCobrancaEncerradaInformada: EntityPagedResult<RecuperacaoCredito>;
    public opcoesPaginacaoAposCobrancaEncerradaInformada: number[];

    public atributosPaginacaoComponenteListagemAposLiquidacaoInformada: EntityPagedResult<RecuperacaoCredito>;
    public opcoesPaginacaoAposLiquidacaoInformada: number[];

    public estadoFiltroPendencias = {
        RECUPERACAO_APOS_SALDO_COM_BENEFICIARIO_LIQUIDADO: 'undefined',
        RECUPERACAO_APOS_COBRANCA_ENCERRADA_INFORMADA: 'undefined',
        RECUPERACAO_APOS_LIQUIDACAO_INFORMADA: 'undefined'
    };

    constructor(private service: RecuperacaoCreditoService) {
    }

    ngOnInit() {
        this.opcoesPaginacaoAposSaldoComBeneficiarioLiquidado = [10, 15, 20];

        this.atributosPaginacaoComponenteListagemAposSaldoComBeneficiarioLiquidado = {
            page: 1,
            pageSize: this.opcoesPaginacaoAposSaldoComBeneficiarioLiquidado[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };

        this.opcoesPaginacaoAposCobrancaEncerradaInformada = [10, 15, 20];

        this.atributosPaginacaoComponenteListagemAposCobrancaEncerradaInformada = {
            page: 1,
            pageSize: this.opcoesPaginacaoAposCobrancaEncerradaInformada[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };

        this.opcoesPaginacaoAposLiquidacaoInformada = [10, 15, 20];

        this.atributosPaginacaoComponenteListagemAposLiquidacaoInformada = {
            page: 1,
            pageSize: this.opcoesPaginacaoAposLiquidacaoInformada[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };

        this.buscarRecIncAposSaldoComBeneficiarioLiquidado();
        this.buscarRecIncAposCobrancaEncerradaInformada();
        this.buscarRecIncAposLiquidacaoInformada();
    }

    buscarRecIncAposSaldoComBeneficiarioLiquidado() {
        this.service.getRecuperacoesCreditoInconsistentesPorTipo(
                'RECUPERACAO_APOS_SALDO_COM_BENEFICIARIO_LIQUIDADO',
                this.atributosPaginacaoComponenteListagemAposSaldoComBeneficiarioLiquidado.page,
                this.atributosPaginacaoComponenteListagemAposSaldoComBeneficiarioLiquidado.pageSize,
                this.somenteResolvidasAposSaldoComBeneficiarioLiquidado
            ).subscribe((resp) => {
                this.recIncAposSaldoComBeneficiarioLiquidado.length = 0;
                this.recIncAposSaldoComBeneficiarioLiquidado.push(...resp.resultados);
                this.atributosPaginacaoComponenteListagemAposSaldoComBeneficiarioLiquidado.count = resp.totalRegistrosSemPaginacao;
        });
    }

    mudancaPaginaRecIncAposSaldoComBeneficiarioLiquidado(novaPagina: EntityPagedResult<RecuperacaoCredito>) {
        this.atributosPaginacaoComponenteListagemAposSaldoComBeneficiarioLiquidado = novaPagina;
        this.buscarRecIncAposSaldoComBeneficiarioLiquidado();
    }

    mudancaSomenteResolvidasAposSaldoComBeneficiarioLiquidado(somenteResolvidas: boolean) {
        this.somenteResolvidasAposSaldoComBeneficiarioLiquidado = somenteResolvidas;
        this.buscarRecIncAposSaldoComBeneficiarioLiquidado();
    }

    buscarRecIncAposCobrancaEncerradaInformada() {
        this.service.getRecuperacoesCreditoInconsistentesPorTipo(
            'RECUPERACAO_APOS_COBRANCA_ENCERRADA_INFORMADA',
            this.atributosPaginacaoComponenteListagemAposCobrancaEncerradaInformada.page,
            this.atributosPaginacaoComponenteListagemAposCobrancaEncerradaInformada.pageSize,
            this.somenteResolvidasAposCobrancaEncerradaInformada
        ).subscribe((resp) => {
            this.recIncAposCobrancaEncerradaInformada.length = 0;
            this.recIncAposCobrancaEncerradaInformada.push(...resp.resultados);
            this.atributosPaginacaoComponenteListagemAposCobrancaEncerradaInformada.count = resp.totalRegistrosSemPaginacao;
        });
    }

    mudancaPaginaRecIncAposCobrancaEncerradaInformada(novaPagina: EntityPagedResult<RecuperacaoCredito>) {
        this.atributosPaginacaoComponenteListagemAposCobrancaEncerradaInformada = novaPagina;
        this.buscarRecIncAposCobrancaEncerradaInformada();
    }

    mudancaSomenteResolvidasAposCobrancaEncerradaInformada(somenteResolvidas: boolean) {
        this.somenteResolvidasAposCobrancaEncerradaInformada = somenteResolvidas;
        this.buscarRecIncAposCobrancaEncerradaInformada();
    }

    buscarRecIncAposLiquidacaoInformada() {
        this.service.getRecuperacoesCreditoInconsistentesPorTipo(
            'RECUPERACAO_APOS_LIQUIDACAO_INFORMADA',
            this.atributosPaginacaoComponenteListagemAposLiquidacaoInformada.page,
            this.atributosPaginacaoComponenteListagemAposLiquidacaoInformada.pageSize,
            this.somenteResolvidasAposLiquidacaoInformada
        ).subscribe((resp) => {
            this.recIncAposLiquidacaoInformada.length = 0;
            this.recIncAposLiquidacaoInformada.push(...resp.resultados);
            this.atributosPaginacaoComponenteListagemAposLiquidacaoInformada.count = resp.totalRegistrosSemPaginacao;
        });
    }

    mudancaPaginaRecIncAposLiquidacaoInformada(novaPagina: EntityPagedResult<RecuperacaoCredito>) {
        this.atributosPaginacaoComponenteListagemAposLiquidacaoInformada = novaPagina;
        this.buscarRecIncAposLiquidacaoInformada();
    }

    mudancaSomenteResolvidasAposLiquidacaoInformada(somenteResolvidas: boolean) {
        this.somenteResolvidasAposLiquidacaoInformada = somenteResolvidas;
        this.buscarRecIncAposLiquidacaoInformada();
    }

}